import React, { useEffect, useCallback, useState } from 'react';
import AddInCircleStrokeIcon from '@ad-scripts/presentation/components/common/icons/stroke/add-in-circle-stroke';
import DashInCircleStrokeIcon from '@ad-scripts/presentation/components/common/icons/stroke/dash-in-circle-stroke';
import { MAX_SCALE, MIN_SCALE, SCALE_STEP } from 'src/presentation/components/pages/ivr/components/ivrTree/hooks/useD3';
import { Toolbar, ToolbarBtn, ToolbarOrientation } from './toolbar';

const TreeToolbar = ({ disabled, onZoomIn, onZoomOut, transformScale }) => {
  const [zoomInDisable, setZoomInDisable] = useState(true);
  const [zoomOutDisable, setZoomOutDisable] = useState(true);

  useEffect(() => {
    const scale = Math.round(transformScale * 100) / 100;
    setZoomInDisable(scale >= MAX_SCALE - SCALE_STEP);
    setZoomOutDisable(scale <= MIN_SCALE + SCALE_STEP);
  }, [transformScale]);

  const clickZoomInButton = useCallback(
    e => {
      e.stopPropagation();
      if (zoomInDisable) {
        return false;
      }
      onZoomIn && onZoomIn();
    },
    [onZoomIn, zoomInDisable]
  );

  const clickZoomOutButton = useCallback(
    e => {
      e.stopPropagation();
      if (zoomOutDisable) {
        return false;
      }
      onZoomOut && onZoomOut();
    },
    [onZoomOut, zoomOutDisable]
  );

  return (
    <Toolbar orientation={ToolbarOrientation.VERTICAL}>
      <ToolbarBtn
        svg={AddInCircleStrokeIcon}
        onClick={clickZoomInButton}
        disabled={disabled || zoomInDisable}
        hint="Zoom In"
      />
      <ToolbarBtn
        svg={DashInCircleStrokeIcon}
        onClick={clickZoomOutButton}
        disabled={disabled || zoomOutDisable}
        hint="Zoom Out"
      />
    </Toolbar>
  );
};

export default TreeToolbar;
